











import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';
import PageSection from '@/uikit/components/AppDefaultLayout/components/sections/PageSection.vue';
import { layoutUtils } from '../utils/utils';

export default {
  components: { PageSection },
  props: {
    layoutHeaderConfig: {
      type: Object as () => LayoutConfig['header'],
    },
    layoutDataSet: {
      type: Object as () => LayoutDataSet,
    },
  },
  data() {
    return {
      utils: layoutUtils,
    };
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/header/Header.vue